import React from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import style from "./style.css";
import { Div } from "/app/src/component";
import EmojiOption from "./EmojiOption";
import markdownToDraft from "./markdownToDraft";
import { convertToRaw, convertFromRaw } from "draft-js";
function textToEditorState(text) {
  if (!text) return EditorState.createEmpty();
  let markToRawDraft;
  try {
    markToRawDraft = JSON.parse(text);
  } catch (error) {
    // legacy move
    markToRawDraft = markdownToDraft(text, {
      preserverNewLines: true,
    });
  }
  const contentState = convertFromRaw(markToRawDraft);
  const editorState = EditorState.createWithContent(contentState);
  return editorState;
}
function editorStateToJson(editorState) {
  let currentContent = editorState.getCurrentContent();
  let rawContent = convertToRaw(currentContent);
  return JSON.stringify(rawContent);
}

let toolbarOptions = {
  inline: {
    options: ["bold", "italic"],
  },
  link: {
    inDropdown: false,
    showOpenOptionOnHover: true,
    defaultTargetOption: "_self",
    options: ["link", "unlink"],
  },
};

export default class CustomEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: textToEditorState(props.text),
    };
    this.onLocalEditorStateChange = this.onLocalEditorStateChange.bind(this);
  }

  onLocalEditorStateChange(editorState) {
    this.setState({ editorState: editorState });
    this.props.onTextChange(editorStateToJson(editorState));
  }
  renderLabel(label) {
    if (!label) return null;
    return <p style={{ color: "#333333", fontSize: "20px" }}>{label}</p>;
  }
  render() {
    // Warning: this is obscure, but either,
    // the component is uncontrollable, then it will take two input: text and onTextChange and handle the editor state by it self
    // else we use editor state that come from outside of it
    const currentEditorState =
      this.props.text !== undefined
        ? this.state.editorState
        : this.props.editorState;
    const currentOnChangeHandler =
      this.props.text !== undefined
        ? this.onLocalEditorStateChange
        : this.props.onEditorStateChange;

    let { label, option, keyBindingFn } = this.props;
    let { customButtons } = this.props;
    customButtons = customButtons || [];

    option = option ? option : "default";

    let options = {
      advance: ["inline", "link", "image", "embedded"],
      default: ["inline", "link"],
    };

    return (
      <Div w="100%" height={this.props.height}>
        {this.renderLabel(label)}
        <Editor
          editorState={currentEditorState}
          onEditorStateChange={currentOnChangeHandler}
          toolbar={{
            ...toolbarOptions,
            options: options[option],
          }}
          stripPastedStyles={true}
          wrapperClassName={style.EditorWrapper}
          editorClassName={style.Editor}
          toolbarCustomButtons={[<EmojiOption />, ...customButtons]}
          toolbarClassName={style.Toolbar}
          keyBindingFn={keyBindingFn}
          placeholder={this.props.placeholder}
        />
        {this.props.children}
      </Div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Markdown/Editor.js